(ns manage.content-variant-page.targeting-value.view
  (:require [common.ui.list :as ui.list]
            [manage.content-configuration-page.view.list :as lv]
            [manage.content-variant-page.rule.view :as rule]
            [manage.content-variant-page.targeting-value.db]
            [manage.content-variant-page.targeting-value.default :as default]
            [manage.content-variant-page.view.list :refer [configure-button]]
            [re-frame.core :as rf]
            [uix.core :refer [$]]))

(defn entity-cfg-dynamic [tv]
  {:entity/ref tv
   :entity/label ($ default/label-without-default {:tv tv})})

(defn list-cfg-dynamic [tk]
  {:entity/ref tk
   :entity/label "Dynamic targeting values"
   :entity/read-only? true
   :list/items :targeting-key/targeting-value
   :list/->item-cfg entity-cfg-dynamic})

(defn configure-targeting-button
  [tv]
  (let [placeholder @(rf/subscribe [:targeting-value/placeholder (:eid tv)])]
    [configure-button #(rf/dispatch [:mapped-targeting-value/configure placeholder (:eid tv)])
     (if @(rf/subscribe [:resource.content-function-version/active-version? "published"])
       "View configuration"
       "Configure targeting")]))

(defn entity-cfg-mapped-without-rule [tv]
  {:entity/ref tv
   :entity/label :targeting-value/value
   :list-item/details [configure-targeting-button tv]})

(defn list-cfg-mapped-without-rule [tk]
  {:entity/ref tk
   :entity/read-only? true
   :list/items [:mapped-targeting-key/targeting-values-without-rule (:eid tk)]
   :list/->item-cfg entity-cfg-mapped-without-rule})

(defn list-mapped [p tk]
  [ui.list/concatenate
   lv/view
   (rule/list-cfg-mapped p)
   (list-cfg-mapped-without-rule tk)])
